import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { useFeatures } from '@wkda/feature-toggle';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { useLayoutQuery } from '../hooks/useDataHooks';
import { GDPRBanner } from '../GDPRBanner';
import { ModalManager } from '../ModalManager';
import { useAppConfiguration } from '../hooks/useAppConfiguration';
export function EmptyLayout(_ref) {
  let {
    children,
    customBanner: CustomBanner,
    className,
    customGDPRBanner
  } = _ref;
  const {
    status
  } = useLayoutQuery();
  const {
    hasCustomerAccount
  } = useFeatures();
  const {
    fullLocale
  } = useAppConfiguration();

  if (status === 'success') {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ModalManager.Provider, null, /*#__PURE__*/React.createElement(GDPRBanner, {
      customGDPRBanner: customGDPRBanner
    }), /*#__PURE__*/React.createElement("div", {
      className: cx("locale-" + fullLocale.toLowerCase(), className, {
        'has-customer-account': hasCustomerAccount,
        'no-customer-account': !hasCustomerAccount
      })
    }, CustomBanner && /*#__PURE__*/React.createElement(CustomBanner, null), /*#__PURE__*/React.createElement("div", {
      className: "container main-body-container"
    }, children))), /*#__PURE__*/React.createElement(ReactQueryDevtools, null));
  }

  return null;
}
EmptyLayout.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  customBanner: PropTypes.oneOfType([PropTypes.node, PropTypes.func])
};